import { Avatar, Badge, Box, Button, Flex, Grid, GridItem, Tab, TabList, TabPanel, TabPanels, Tabs, Text, } from '@chakra-ui/react';
import MyDiv from './onboardCandidateProfile.style';
import { ApproveAllCard, CandidateDetailsCard, DocumentUploadCard, EmployementExperinceCard, IdentifyBanking } from '../components';
import { useEffect, useState } from 'react';
import { ICandidateList } from '../OnboardCandidateList/modal';
import { useLocation } from 'react-router-dom';
import { AlertCard, CustomToast } from '../../../../components';
import { baseUrl, useFetch } from '../../../../hooks/useFetch';
import { useAuth } from '../../../../hooks/useAuth';
import DummyPerson from "../../../../assets/images/DummyPerson.svg"
import { showDate } from '../../../../utilities/helper';

const OnboardCandidateProfile = () => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [selectedCandidate, setSelectedCandidate] = useState<ICandidateList | null>(null);
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  const { loginObj } = useAuth();
  const [reload, setReload] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const { hasPermission } = useAuth()

  const location = useLocation()
  const candidate: any = location.state?.candidate_Id;

  async function onBoardingProfileDetail() {
    const response = await fetchApi('OfferAndOnBoarding/selectionCandidateDetail', "GET", null, `candidate_Id=${candidate}`, "");
    if (response) {
      setSelectedCandidate(response);
    }
  }

  const confirmSendOfferLetter = async () => {
    if (!selectedCandidate) return;

    const response = await fetchApi(`OfferAndOnBoarding/sendOfferLetter?candidateId=${selectedCandidate.candidate_Id}`, "POST", null, null, "Offer Letter sent successfully");
    if (response) {
      addToast({ message: "Offer Letter sent successfully", status: "success" });
      onBoardingProfileDetail();
    }
  }

  useEffect(() => {
    onBoardingProfileDetail();
  }, [candidate, reload]);

  useEffect(() => {
    if (!selectedCandidate?.employee_Id) return;

    const fetchAvatar = async () => {
      try {
        const res = await fetch(`${baseUrl}Hrlense_Employee/profilepic/${selectedCandidate?.employee_Id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${loginObj?.token || ""}`,
          },
        });

        if (!res.ok) throw new Error("Avatar not found");



        const blob = await res.blob();
        if (blob.size > 0) {
          setAvatarUrl(URL.createObjectURL(blob));
        } else {
          setAvatarUrl(null);
        }
      } catch (err) {
        console.error("Error fetching avatar", err);
        setAvatarUrl(null);
      }
    };

    fetchAvatar();
  }, [selectedCandidate?.employee_Id]);


  return (
    <MyDiv>
      <Box className="page_wrapper ">
        <Flex className="page_heading flex_header">
          <Text className="font-poppins text_medium text_3xl">HR Review - Candidate On Boarding</Text>
        </Flex>
        <Grid className='grid_container' py={5} gap={7}>
          <GridItem colSpan={12}>
            <Box className="card">
              <Box px={3}>
                <Flex justify="space-between" align="center">
                  <Flex align="center">
                    <Avatar className="Avatar" src={avatarUrl || DummyPerson} name={selectedCandidate?.candidate_Name} size="xl" mr={4} />
                    <Box>
                      <Text className="font-poppins text_medium text_xl" mb={2}> {selectedCandidate?.candidate_Name} </Text>
                      <Text className="font-poppins text_regular text_lg" mb={2}> {selectedCandidate?.job_profile_Name}</Text>
                      <Flex gap={5}>
                        <Text className="font-poppins text_medium text_xl">Candidate Id:
                          <Text as="span" className="font-poppins text_md text_md" > {selectedCandidate?.candidate_Id}</Text>
                        </Text>
                        <Text className="font-poppins text_medium text_xl">Offered Salary:
                          <Text as="span" className="font-poppins text_md text_md" > {selectedCandidate?.offered_Salary} </Text>
                        </Text>
                        <Text className="font-poppins text_medium text_xl">Joining Date:
                          <Text as="span" className="font-poppins text_md text_md" > {showDate(selectedCandidate?.date_Of_Joining)} </Text>
                        </Text>
                      </Flex>
                    </Box>
                  </Flex>
                  <Flex justifyContent={"flex-end"} gap={4}>
                    <Badge className='badge' backgroundColor={selectedCandidate?.joining_Status === 9 ? "#E5F2E5" : "#EF9B4824"} color={selectedCandidate?.status_Name.trim().toLocaleLowerCase() === "joined" ? "#008000" : "#FFA500"}>
                      {selectedCandidate?.status_Name.toLocaleLowerCase() === "joined" ? "Approved" : "Pending Review"}
                    </Badge>
                    {hasPermission("OffersOnBording", "sendOfferLetter") && selectedCandidate?.status_Name.toLocaleLowerCase() === "joined" && (
                      <Button className='btn font-poppins text_sm text_medium' backgroundColor="#E5F2E5" color="#008000" onClick={() => setIsOpen(true)}>Send Offer Letter</Button>
                    )}
                  </Flex>
                </Flex>
              </Box>
            </Box>

          </GridItem>
          <GridItem colSpan={7} py={3} className='tab-list-container' >

            <Box>

              <Tabs colorScheme="green" index={activeTabIndex} onChange={(index) => setActiveTabIndex(index)}
              >
                <Box className="card" overflowY="auto">
                  <TabList gap={8}>
                    <Tab className='font-poppins text_md text_medium' whiteSpace="nowrap">Candidate Details</Tab>
                    <Tab className='font-poppins text_md text_medium' whiteSpace="nowrap">Identify and Banking</Tab>
                    <Tab className='font-poppins text_md text_medium' whiteSpace="nowrap">Employment & Experience</Tab>
                    <Tab className='font-poppins text_md text_medium' whiteSpace="nowrap">View Document</Tab>
                  </TabList>
                </Box>
                <TabPanels>
                  <TabPanel>
                    <CandidateDetailsCard basicDetails={selectedCandidate} />
                  </TabPanel>

                  <TabPanel>
                    <IdentifyBanking identifyBanking={selectedCandidate} />
                  </TabPanel>

                  <TabPanel>
                    <EmployementExperinceCard experience={selectedCandidate} />
                  </TabPanel>

                  <TabPanel>
                    {activeTabIndex === 3 && <DocumentUploadCard document={selectedCandidate} />}
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Box>

          </GridItem>
          <GridItem colSpan={5} mt={3}>
            <ApproveAllCard candidateDetail={selectedCandidate} reload={reload} setReload={setReload} />
          </GridItem>
        </Grid>
      </Box>
      <AlertCard isOpen={isOpen} onClose={() => setIsOpen(false)} onConfirm={confirmSendOfferLetter} title="Send Offer Letter" description="Are you sure you want to send the offer letter?" confirmLabel='Send' cancelLabel='Cancel' colorScheme='green' />


    </MyDiv>
  );
};

export default OnboardCandidateProfile;